// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"501":"89e6d31b","743":"416f2696"}[chunkId] + ".chunk.js";
};